import React from 'react';
import { Button } from '@material-ui/core';
import { GetApp } from '@material-ui/icons';

interface Props {
  disabled?: boolean;
  iconOnly?: boolean;
  onClick: () => void;
}

export const CertificateDownloadButton = ({ disabled, iconOnly, onClick }: Props) => (
  <Button
    onClick={onClick}
    disabled={disabled}
    aria-label='Download certificate'
    startIcon={iconOnly ? undefined : <GetApp style={{ fontSize: '14px' }} />}
    style={{
      backgroundColor: 'transparent',
      color: '#646464',
      border: '1px solid #d9d9d9',
      borderRadius: '4px',
      padding: iconOnly ? '4.5px 6px' : '4.5px 12px',
      fontSize: '12px',
      fontWeight: 600,
      textTransform: 'none',
      minWidth: 'auto',
      flexShrink: 0,
    }}
  >
    {iconOnly ? <GetApp style={{ fontSize: '16px' }} /> : 'Download'}
  </Button>
);
